import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import jsPDF from 'jspdf';

interface ReceiptDownloadProps {
  planName: string;
  amount: string;
  date: string;
  transactionId: string;
}

export const ReceiptDownload = ({ planName, amount, date, transactionId }: ReceiptDownloadProps) => {
  const { toast } = useToast();

  const generateReceipt = () => {
    // Initialize PDF document
    const doc = new jsPDF();
    
    // Add logo/header
    doc.setFontSize(20);
    doc.setTextColor(44, 62, 80);
    doc.text("Scienza Health", 105, 20, { align: "center" });
    
    // Add receipt title
    doc.setFontSize(16);
    doc.text("RECEIPT", 105, 35, { align: "center" });
    
    // Add horizontal line
    doc.setLineWidth(0.5);
    doc.line(20, 40, 190, 40);
    
    // Add receipt details
    doc.setFontSize(12);
    doc.setTextColor(68, 68, 68);
    
    const startY = 60;
    const lineHeight = 10;
    
    // Receipt content
    doc.text(`Date: ${date}`, 20, startY);
    doc.text(`Transaction ID: ${transactionId}`, 20, startY + lineHeight);
    doc.text(`Plan: ${planName}`, 20, startY + lineHeight * 2);
    doc.text(`Amount: ${amount}`, 20, startY + lineHeight * 3);
    
    // Add footer
    doc.setFontSize(10);
    doc.text("Thank you for your subscription!", 105, 250, { align: "center" });
    doc.text("For support, contact: support@scienzahealth.com", 105, 257, { align: "center" });
    
    // Save the PDF
    doc.save(`memorycareai-receipt-${transactionId}.pdf`);

    toast({
      title: "Receipt Downloaded",
      description: "Your receipt has been downloaded as a PDF.",
    });
  };

  return (
    <Button 
      variant="outline" 
      onClick={generateReceipt}
      className="w-full flex items-center justify-center gap-2"
    >
      <Download className="h-4 w-4" />
      Download Receipt
    </Button>
  );
};